import { render, staticRenderFns } from "./AddDocument.vue?vue&type=template&id=46285ea8&"
import script from "./AddDocument.vue?vue&type=script&lang=ts&"
export * from "./AddDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports